// Load Google Analytics (gtag) only in production
import { isProduction } from "@/services/env.service";

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export function loadGtag(): void {
  try {
    if (isProduction) {
      const GA_ID = "G-G7K8K69Q7E"; // keep the existing measurement id

      // inject gtag script
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(script);

      // initialize gtag
      window.dataLayer = window.dataLayer || [];
      function gtag(...args: any[]) {
        window.dataLayer.push(args);
      }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", GA_ID);
    }
  } catch (e) {
    // swallow errors to avoid crashing the app in any environment
    // eslint-disable-next-line no-console
    console.error("Error loading gtag:", e);
  }
}
